module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "permissions-by-device-container"
  }, [_c('Snackbar', {
    attrs: {
      "text": _vm.snackbar.text,
      "color": _vm.snackbar.color,
      "timeOut": _vm.snackbar.timeOut,
      "show": _vm.snackbar.show
    },
    on: {
      "update:show": function($event) {
        return _vm.$set(_vm.snackbar, "show", $event)
      }
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "permissions-by-device"
  }, [_c('v-col', {
    staticClass: "py-0",
    staticStyle: {
      "text-align": "-webkit-center"
    },
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "id": "profile-pic",
      "width": "100%",
      "height": "100%",
      "src": _vm.profilePicSrc
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "cols": "12",
      "sm": "9",
      "offset-sm": "1"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "title-text text-left"
  }, [_vm._v(_vm._s(_vm.$t('PermissionsByDevice.title', [_vm.userData.name, _vm.$t(("Roles." + (_vm.userData.role)))])))])])], 1), _vm._v(" "), (_vm.devicesPermissions.length) ? [_c('v-container', {
    staticClass: "table-container"
  }, [_c('v-container', {
    staticClass: "table-div custom-scroll-bar"
  }, [_c('v-row', {
    staticClass: "pt-3 pb-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "offset": "2"
    }
  }, [_c('p', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.failure')))])]), _vm._v(" "), _c('v-col', [_c('p', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.pressure')))])]), _vm._v(" "), _c('v-col', [_c('p', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.off')))])]), _vm._v(" "), _c('v-col', [_c('p', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.position')))])]), _vm._v(" "), _c('v-col', [_c('p', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.irrigationOrders')))])])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('p', {
    staticClass: "row-text-bold my-0"
  }, [_vm._v(_vm._s(_vm.$t('PermissionsByDevice.all')))])]), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeAllPermissions('failure')
      }
    },
    model: {
      value: (_vm.allFailures),
      callback: function($$v) {
        _vm.allFailures = $$v
      },
      expression: "allFailures"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeAllPermissions('pressure')
      }
    },
    model: {
      value: (_vm.allPressure),
      callback: function($$v) {
        _vm.allPressure = $$v
      },
      expression: "allPressure"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeAllPermissions('off')
      }
    },
    model: {
      value: (_vm.allOff),
      callback: function($$v) {
        _vm.allOff = $$v
      },
      expression: "allOff"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeAllPermissions('position')
      }
    },
    model: {
      value: (_vm.allPosition),
      callback: function($$v) {
        _vm.allPosition = $$v
      },
      expression: "allPosition"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeAllPermissions('irrigationOrders')
      }
    },
    model: {
      value: (_vm.allIrrigationOrders),
      callback: function($$v) {
        _vm.allIrrigationOrders = $$v
      },
      expression: "allIrrigationOrders"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.devicesPermissions), function(device) {
    return _c('v-row', {
      key: device.id,
      attrs: {
        "no-gutters": "",
        "justify": "center"
      }
    }, [_c('v-col', {
      staticClass: "align-self-center"
    }, [_c('p', {
      staticClass: "row-text my-0"
    }, [_vm._v(_vm._s(device.name))])]), _vm._v(" "), _c('v-col', [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.switchClick('failure')
        }
      },
      model: {
        value: (device.permissions.failure),
        callback: function($$v) {
          _vm.$set(device.permissions, "failure", $$v)
        },
        expression: "device.permissions.failure"
      }
    })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.switchClick('pressure')
        }
      },
      model: {
        value: (device.permissions.pressure),
        callback: function($$v) {
          _vm.$set(device.permissions, "pressure", $$v)
        },
        expression: "device.permissions.pressure"
      }
    })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.switchClick('off')
        }
      },
      model: {
        value: (device.permissions.off),
        callback: function($$v) {
          _vm.$set(device.permissions, "off", $$v)
        },
        expression: "device.permissions.off"
      }
    })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.switchClick('position')
        }
      },
      model: {
        value: (device.permissions.position),
        callback: function($$v) {
          _vm.$set(device.permissions, "position", $$v)
        },
        expression: "device.permissions.position"
      }
    })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      on: {
        "click": function($event) {
          return _vm.switchClick('irrigationOrders')
        }
      },
      model: {
        value: (device.permissions.irrigationOrders),
        callback: function($$v) {
          _vm.$set(device.permissions, "irrigationOrders", $$v)
        },
        expression: "device.permissions.irrigationOrders"
      }
    })], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "offset": "4"
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.fromNewUser ? _vm.$t('PermissionsByDevice.save') : _vm.$t('PermissionsByDevice.back')))])], 1)], 1)] : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-center empty-devices"
  }, [_vm._v(_vm._s(_vm.$t('UsersPermissions.emptyDevicesList')))])])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da439b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser/PermissionsByDevice.vue
// module id = 1720
// module chunks = 0